import { SelectOptionType } from '@octano/global-ui';

export interface IdentificationQuery {
  identificationTypeId: string;
  identification: string;
  countryId?: string;
}

export interface SearchAdminAccount {
  Account_id: number;
  Account_identification: string;
  Account_identificationTypeId: string;
  Account_identificationTypeName: string;
  Account_name: string;
  Account_paternalLastName: string;
  Account_maternalLastName: string;
  Account_birthday: string;
  Account_phone: string | null;
  Account_email: string | null;
  Account_personalEmail: string | null;
  Account_teacherId: string | null;
  Account_studentId: string | null;
  Account_isActive: boolean;
  Country_id: string | null;
  Country_name: string | null;
  Nationality_id: string | null;
  Nationality_name: string | null;
  Role_id: number | null;
  Role_name: string | null;
}

export interface AdminAccountForm {
  id?: number;
  identificationTypeId: string;
  identificationTypeName: string;
  identification: string;
  countryId?: string;
  country?: SelectOptionType;
  names: string;
  lastnamePather: string;
  lastnameMother: string;
  birthdate?: Date;
  nationality?: SelectOptionType;
  phone: string;
  personalEmail: string;
  email: string;
  role?: SelectOptionType;
  teacherId?: string | null;
  studentId?: string | null;
  isActive: boolean;
}

export interface CreateAdminAccountBody {
  identificationTypeId: string;
  identification: string;
  countryId?: string;
  name: string;
  paternalLastName: string;
  maternalLastName: string;
  birthday: string;
  personalEmail: string;
  phone: string;
  email: string;
  nationalityId?: string | number;
  rolesId?: number | null;
}

export type UpdateAdminAccountBody = Pick<
  CreateAdminAccountBody,
  | 'name'
  | 'paternalLastName'
  | 'maternalLastName'
  | 'birthday'
  | 'nationalityId'
  | 'personalEmail'
  | 'email'
  | 'phone'
  | 'rolesId'
> & { id?: number };

export enum PermissionType {
  Student = 'Alumno',
  Teacher = 'Docente',
}
